import type { SuggestedAddress, ValidateAddressInput } from '../../../core/models/address-validate';

/**
 * Builds a SuggestedAddress from the user's typed validate request entry.
 * Used when AVS returns invalid with no actionable suggestion (OM-513 / ESN empty-alternate backfill).
 */
export function buildSuggestedAddressFromTypedEntry(
  typedEntry: ValidateAddressInput,
): SuggestedAddress {
  const postalCompact = typedEntry.postalCode.replace(/\s+/g, '').toUpperCase();
  const postalCode =
    postalCompact.length === 6
      ? `${postalCompact.slice(0, 3)} ${postalCompact.slice(3)}`
      : typedEntry.postalCode.trim();

  return {
    addressee: typedEntry.addressee.trim(),
    addressLine1: typedEntry.addressLine1.trim(),
    addressLine2: (typedEntry.addressLine2 ?? '').trim(),
    municipalityName: typedEntry.municipalityName.trim(),
    provinceCode: typedEntry.provinceCode.trim().toUpperCase(),
    postalCode,
  };
}
